import { VerifierSingleCardTemplate } from "../../../../templates";
import { ChangePasswordForm } from "../../../shared";

const ChangePassword = (): JSX.Element => {
  return (
    <VerifierSingleCardTemplate pageTitle="Change Password">
      <ChangePasswordForm />
    </VerifierSingleCardTemplate>
  );
};

export default ChangePassword;
